import React from 'react';
import '../../styles/sustainability/main.css';

const Main = () => {
    return (
        <section id="sustainAbility">
            <div className="container">
                <div className="logo">
                    <img
                        className="w-100"
                        src="../../assets/images/sustainability-goals/banner.png"
                        alt=""
                    />
                </div>
                <div className="goals">
                    <h2 className="my-heading">Sustainable Development Goals</h2>
                    <div className="boxes">
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/1.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/2.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/3.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/4.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/5.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/6.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/7.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/8.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/9.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/10.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/11.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/12.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/13.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/14.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/15.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/16.png" alt="" />
                        </div>
                        <div className="box">
                            <img src="../../assets/images/sustainability-goals/17.png" alt="" />
                        </div>
                        <div className="box">
                            <img
                                src="../../assets/images/sustainability-goals/logo.png"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                {/* <div class="gols-lists">
            <div class="list">
                <ul>
                    <li style="margin-bottom: 10px;"><a style="background-color: #EC1628; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/1.%20No%20poverty.pdf" target="_blank" rel='noreferrer'>SDG 1: No poverty</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #D3A125; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/2.%20Zero%20hunger.pdf" target="_blank" rel='noreferrer'>SDG 2: Zero hunger</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #289C46; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/3.%20Good%20health%20and%20well-being.pdf" target="_blank" rel='noreferrer'>SDG 3: Good health and well-being</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #C31930; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/4.%20Quality%20Education.pdf" target="_blank" rel='noreferrer'>SDG 4: Quality education</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #EF3E25; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/5.%20Gender%20equality.pdf" target="_blank" rel='noreferrer'>SDG 5: Gender equality </a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #00AFD9; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/6.%20Clean%20water%20and%20sanitation.pdf" target="_blank" rel='noreferrer'>SDG 6: Clean water and sanitation</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #FDB80B; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/7.%20Affordable%20and%20clean%20energy.pdf" target="_blank" rel='noreferrer'>SDG 7: Affordable and clean energy </a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #8F1838; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/8.%20Decent%20work%20and%20economic%20growth.pdf" target="_blank" rel='noreferrer'>SDG 8: Decent work and economic growth</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #F16D22; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/9.%20Industry,%20innovation%20and%20infrastructure.pdf" target="_blank" rel='noreferrer'>SDG 9: Industry, innovation and infrastructure</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #E10D84; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/10.%20Reduced%20inequalities.pdf" target="_blank" rel='noreferrer'>SDG 10: Reduced inequalities</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #F99E20; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/11.%20Sustainable%20cities%20and%20economies.pdf" target="_blank" rel='noreferrer'>SDG 11: Sustainable cities and communities </a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #D08E25; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/12.%20Responsible%20consumption%20and%20production.pdf" target="_blank" rel='noreferrer'>SDG 12: Responsible consumption and production</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #46783A; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/13.%20Climate%20action.pdf" target="_blank" rel='noreferrer'>SDG 13: Climate action</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #007EBC; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/14.%20Life%20below%20water.pdf" target="_blank" rel='noreferrer'>SDG 14: Life below water</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #3DB147; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/15.%20Life%20on%20land.pdf" target="_blank" rel='noreferrer'>SDG 15: Life on land </a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #00548B; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/16.%20Peace,%20justice%20and%20strong%20institutions.pdf" target="_blank" rel='noreferrer'>SDG 16: Peace, justice, and strong institutions</a></li>
                    <li style="margin-bottom: 10px;"><a style="background-color: #123367; padding: 5px; color: #fff; text-decoration: none;" href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/17.%20Partnership%20for%20the%20goals.pdf" target="_blank" rel='noreferrer'>SDG 17: Partnerships for the goals</a></li>
                </ul>
            </div>
            <div class="img">
                <img src="../../assets/images/sustainability-goals/list.png" alt="">
            </div>
        </div> */}
                {/* <h2 class="my-heading text-center mt-3">SUSTAINABILITY @ CCSU</h2>
        <div class="d-flex justify-content-center">
            <img class="w-50" src="../../assets/images/sustainability-goals/earth.jpg" alt="">
        </div>
        <h2 class="my-heading text-center mt-3">Think beyond today, act for tomorrow</h2>
       <div class="desc">
        <p>
            CCSU is passionately dedicated to advancing the United Nations Sustainable
            Development Goals (SDGs), which serve as a universal roadmap for a brighter,
            more equitable future. Our commitment spans across a wide range of academic
            programs, cutting-edge research, innovative projects, and dynamic support for
            startups and entrepreneurship. We also engage in meaningful collaborations,
            community outreach, and initiatives that aim to tackle the world’s most pressing
            challenges from eradicating poverty to combating climate change. By aligning
            ourselves with the SDGs, we recognize our role as an educational institution in
            shaping a better world, and we take pride in contributing to the collective global
            effort for sustainability and justice. Our students, faculty, and researchers are driven
            by an unwavering passion to tackle real-world problems and develop solutions that
            make a measurable, positive impact. Through collaboration and innovation, we
            channel our collective expertise and enthusiasm to create tangible outcomes that
            support the SDGs. In doing so, we foster a vibrant culture of global citizenship,
            social responsibility, and environmental stewardship. At CCSU, we are more than
            just a place of learning, we are a catalyst for transformation, united in our mission to
            create a better, more sustainable future. Our commitment goes beyond academics;
            we actively engage in initiatives that address the world’s most urgent challenges,
            empowering individuals to lead with purpose and impact. Together, we are shaping
            a tomorrow where innovation, equity, and Eco-consciousness drive positive change
            for all. We are building a legacy of progress through collaboration, creativity, and
            action that extends far beyond the classroom and into the world.
        </p>
       </div> */}
                <ul className="nav nav-tabs pt-3" id="sustainabilityTabs" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link active"
                            id="about-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#about"
                            type="button"
                            role="tab"
                        >
                            About Sustainability
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link"
                            id="goals-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#goals"
                            type="button"
                            role="tab"
                        >
                            Sustainability Goals
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link"
                            id="activity-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#activity"
                            type="button"
                            role="tab"
                        >
                            Activity Report
                        </button>
                    </li>
                </ul>
                <div className="tab-content mt-3" id="sustainabilityTabsContent">
                    <div className="tab-pane fade show active" id="about" role="tabpanel">
                        <h1 className="p-2 mb-2 my-heading">SUSTAINABILITY @ CCSU</h1>
                        <div className="p-3 d-flex gap-2 justify-content-between align-items-center madhukarshroti">
                            <div className="w-100">
                                <img
                                    src="../../assets/images/sustainability-goals/earth.jpg"
                                    alt=""
                                />
                            </div>
                            <div className="text-justify">
                                <h2 className="my-heading">Think beyond today, act for tomorrow</h2>
                                <p>
                                    CCSU is passionately dedicated to advancing the United Nations
                                    Sustainable Development Goals (SDGs), which serve as a universal
                                    roadmap for a brighter, more equitable future. Our commitment
                                    spans across a wide range of academic programs, cutting-edge
                                    research, innovative projects, and dynamic support for startups
                                    and entrepreneurship. We also engage in meaningful collaborations,
                                    community outreach, and initiatives that aim to tackle the world's
                                    most pressing challenges from eradicating poverty to combating
                                    climate change.
                                </p>
                                <p>
                                    By aligning ourselves with the SDGs, we recognize our role as an
                                    educational institution in shaping a better world, and we take
                                    pride in contributing to the collective global effort for
                                    sustainability and justice. Our students, faculty, and researchers
                                    are driven by an unwavering passion to tackle real-world problems
                                    and develop solutions that make a measurable, positive impact.
                                </p>
                                <p>
                                    Through collaboration and innovation, we channel our collective
                                    expertise and enthusiasm to create tangible outcomes that support
                                    the SDGs. In doing so, we foster a vibrant culture of global
                                    citizenship, social responsibility, and environmental stewardship.
                                    At CCSU, we are more than just a place of learning, we are a
                                    catalyst for transformation, united in our mission to create a
                                    better, more sustainable future.
                                </p>
                                <p>
                                    Our commitment goes beyond academics; we actively engage in
                                    initiatives that address the world’s most urgent challenges,
                                    empowering individuals to lead with purpose and impact. Together,
                                    we are shaping a tomorrow where innovation, equity, and
                                    eco-consciousness drive positive change for all. We are building a
                                    legacy of progress through collaboration, creativity, and action
                                    that extends far beyond the classroom and into the world.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="activity" role="tabpanel">
                        <div className="container">
                            <h1 className="my-heading fw-bold p-2 mb-2">ACTIVITIES/REPORTS</h1>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Good health and well-being</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Medical Camps &amp; Health Care Initiatives</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/medical-camp.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Quality Education</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Employment or Skill Development Training Programs</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Employment%20or%20Skill%20Development%20Training%20Programs%20Final.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Environmental Education and Awareness Programs</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Environmental%20Education%20and%20awareness%20programs.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Affordable and clean energy</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Energy from Food Waste and Biogas Generation</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Energy%20from%20Food%20Waste%20and%20Biogas%20Generation.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>SOLAR PANEL REPORT</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Solar%20Panel%20Policy%207_Final.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Sustainable cities and economies</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Report on Sustainable Horticultural Practices</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Sustainable%20Horticultural%20Practices.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Strategies for Carbon Footprint Reduction</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Report%20Carbon%20Footprint.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Life below water</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Plastic free campus</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Report%20on%20Plastic-Free%20Campus.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Life on land</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Tree Plantation</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Tree%20Plantation%20Activity%20Report%20Final.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Biodiversity and Afforestation</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Biodiversity%20and%20Afforestation.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Partnership for the goals</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Strengthening Local Education Through Partnerships</td>
                                            <td>
                                                <button className="btn btn-primary btn-download">
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/Partnerships%20with%20local%20schools%20for%20education%20programs%20.pdf"
                                                        target="_blank" rel='noreferrer'
                                                        style={{
                                                            cursor: "text",
                                                            color: "white",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        Click here
                                                    </a>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="goals" role="tabpanel">
                        <h1 className="my-heading">SUSTAINABILITY GOALS</h1>
                        <div className="list">
                            <ul style={{ padding: "0 !important" }}>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#EC1628",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/1.%20No%20poverty.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 1: No poverty
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#D3A125",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/2.%20Zero%20hunger.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 2: Zero hunger
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#289C46",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/3.%20Good%20health%20and%20well-being.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 3: Good health and well-being
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#C31930",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/4.%20Quality%20Education.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 4: Quality education
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#EF3E25",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/5.%20Gender%20equality.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 5: Gender equality{" "}
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#00AFD9",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/6.%20Clean%20water%20and%20sanitation.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 6: Clean water and sanitation
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#FDB80B",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/7.%20Affordable%20and%20clean%20energy.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 7: Affordable and clean energy{" "}
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#8F1838",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/8.%20Decent%20work%20and%20economic%20growth.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 8: Decent work and economic growth
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#F16D22",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/9.%20Industry,%20innovation%20and%20infrastructure.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 9: Industry, innovation and infrastructure
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#E10D84",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/10.%20Reduced%20inequalities.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 10: Reduced inequalities
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#F99E20",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/11.%20Sustainable%20cities%20and%20economies.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 11: Sustainable cities and communities{" "}
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#D08E25",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/12.%20Responsible%20consumption%20and%20production.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 12: Responsible consumption and production
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#46783A",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/13.%20Climate%20action.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 13: Climate action
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#007EBC",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/14.%20Life%20below%20water.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 14: Life below water
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#3DB147",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/15.%20Life%20on%20land.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 15: Life on land{" "}
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#00548B",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/16.%20Peace,%20justice%20and%20strong%20institutions.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 16: Peace, justice, and strong institutions
                                    </a>
                                </li>
                                <li style={{ listStyle: "none", marginBottom: 5 }}>
                                    <a
                                        style={{
                                            display: "block",
                                            backgroundColor: "#123367",
                                            padding: 5,
                                            color: "#fff",
                                            textDecoration: "none"
                                        }}
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/17.%20Partnership%20for%20the%20goals.pdf"
                                        target="_blank" rel='noreferrer'
                                    >
                                        SDG 17: Partnerships for the goals
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Main;